import React from 'react';

const Plus = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        className="horizontal"
        fill="currentColor"
        d="M14.9 17.1H1.1c-.3 0-.5-.1-.8-.3-.2-.2-.3-.5-.3-.8 0-.3.1-.6.3-.8.2-.2.5-.3.8-.3h16.1l13.8-.1c.3 0 .5.1.8.3.2.2.3.5.3.8 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3l-13.8.1"
      ></path>
      <path
        className="vertical"
        fill="currentColor"
        d="M17.2 17.1v13.8c0 .3-.1.5-.3.8-.3.2-.6.3-.9.3-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8V14.8l-.1-13.7c0-.3.1-.5.3-.8.3-.2.5-.3.9-.3.3 0 .6.1.8.3.2.2.3.5.3.8l.1 13.8"
      ></path>
    </svg>
  );
};

export default Plus;
